import React, { Fragment, useState } from 'react';

import Banner from 'buyside/components/presentation/Banner/banner';

import InviteNewMembersForm from './InviteNewMembersForm/InviteNewMembersForm';
import InviteNewMembersSubmitted from './InviteNewMembersForm/InviteNewMembersSubmitted';

import { useInviteNewMembersMutationMutation } from '@interfaces/graphql-typings';

import styles from './InviteNewMembersPageStyles';

const InviteNewMembersPage = ({ isRetail }) => {
  const [errors, setErrors] = useState(false);
  const [formComplete, setFormComplete] = useState(false);

  const [createInvitations] = useInviteNewMembersMutationMutation();

  const handleSubmit = (values, actions) => {
    createInvitations({ variables: values })
      .then(() => {
        setFormComplete(true);
        setErrors(false);
      })
      .catch(() => {
        actions.setSubmitting(false);
        setErrors(true);
      });
  };

  return (
    <Fragment>
      {errors && (
        <div>
          <Banner error>
            There was a problem sending your new member referral(s). Please try again at a later
            time.
            <br />
            If the problem persists, contact support@sumzero.com for assistance.
          </Banner>
          <br />
        </div>
      )}
      <h1 className={styles.header}>Invite New Members</h1>
      {formComplete ? (
        <InviteNewMembersSubmitted />
      ) : (
        <InviteNewMembersForm handleSubmit={handleSubmit} isRetail={isRetail} />
      )}
    </Fragment>
  );
};

export default InviteNewMembersPage;
